import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SideMenuService } from '../../../../shared/side-menu/side-menu.service';
import { Site } from '../../../../shared/models/site.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-polarlink-list-widget',
  templateUrl: './polarlink-list-widget.component.html',
  styleUrls: ['./polarlink-list-widget.component.css']
})
export class PolarlinkListWidgetComponent implements OnInit, OnDestroy {
  @Input() data: any;
  widgetId :string = "plinks_list";
  hideWidget: boolean = false;
  options = {
    hasPrint: false,
    hasExpand: false
  };
  columns : Array<object> = [];
  currentSite: Site = new Site();
  private siteSubscription!: Subscription;

  constructor(private sideMenu: SideMenuService) { }

  ngOnInit() {
    this.siteSubscription =  this.sideMenu.currentSite.subscribe(site => {
      if (site && site.id) {
        this.currentSite = site;
        this.columns = [

          {headerName: "ID", width: 180, field:'rseid'},
          {headerName: "Polarlink S/N", width: 180, field: "serialnumber", filter: 'agTextColumnFilter'},
          {headerName: "Warranty", width: 180, field:'warranty', type: 'number'},
        ];
    
      }
    });
  }

  ngOnDestroy(): void {
    this.siteSubscription?.unsubscribe();
  }

}
